import JSDB from '../fromKotlin/nk';

/**
 * Company-level feature gates from cofc_conf.admin_flags — the platform-admin
 * «שערי פיצ׳רים» toggles in admin-panel. A gate that was never turned on keeps the
 * feature hidden, so companies only see what they actually bought.
 *
 * Read straight off JSDB().userCofcConf (populated by the FETCH base-data build
 * before login resolves), same as getRepLinkFlags() does for the rep_link bitmask.
 */
function adminFlags(): Record<string, unknown> {
    const raw = (JSDB().userCofcConf as { admin_flags?: string | null } | null)?.admin_flags;
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : {};
    } catch {
        return {};
    }
}

export function isCofcFeatureEnabled(gate: string): boolean {
    return String(adminFlags()[gate] ?? 0) === '1';
}

/** Marketing photo collage — cofc_conf.admin_flags.collage. */
export function isCollageEnabled(): boolean {
    return isCofcFeatureEnabled('collage');
}

/**
 * cofc_conf.conversion_rate_blocker == 20.
 * The line conversion is an editable length (אורך). Wrapped qty is the other
 * side (רוחב when that unit is selected). Charged quantity stays
 * value + conversion × wrapped, so existing sums keep working.
 */
export function isVariableConversionRate(): boolean {
    return Number(JSDB().userCofcConf?.conversion_rate_blocker) === 20;
}
